

import { defineComponent, onMounted, onUnmounted} from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
    name: 'ubmchat',
    props:{
   
    },
    setup() {
        const store = useStore()
      
        const initializeChat = () => {
            //router.currentRoute.path
            
            //if (store.getters.isUserAuthenticated && !initChat.value) {


                var
                    var2init = {

                        assessor_first_name:
                            "Administración",

                        assessor_last_name:
                            "Intrasoft",

                        assessor_email:
                            "administracion@intrasoft.es",

                        source:
                            "INTRASOFT",

                        company:
                            "INTRASOFT",

                        unit:
                            "Administración",

                        developer:
                            false,

                        show_userlist:
                            true,

                        minimized:
                            true,

                        /*phone : "+34XXXXX",// string no Formato internacional
                        client_name : "XXXXX" , //string si Nombre del cliente
                        client_lastname: "XXX", // string si Apellidos del cliente
                        client_email: "XXXX@intrasoft.es" 
                        */

                    };


                //console.log(var2init);
                
                //@ts-ignore:disable-next-line
                initChat(var2init);
                
                //initChat.value = true;
            //}
        }


        onMounted(() => {
            if (store.getters.isUserAuthenticated) {
                initializeChat();
            }

        })
        
        onUnmounted(() => {
            /*
            const dv = document.getElementById("root");
            if (dv){
                while (dv.lastElementChild) {
                    dv.removeChild(dv.lastElementChild);
                }

                
            
            }
            */
            
        })

        return {
            
        };
    },
});
